const getOrCreateLegendTable = (chart, id) => {
    const legendContainer = document.getElementById(id);
    let tableContainer = legendContainer.querySelector('table');
    if (!tableContainer) {
        let tableTitles = [];
        if (chart.config.options.unit === 'percentage') {
            tableTitles = ['Segment', 'Percentage'];
        } else {
            tableTitles = ['Segment', 'Amount'];
        }
        tableContainer = `<table class="legend-table has-marker">
                <thead>
                    <tr>`;
        tableTitles.forEach(element => tableContainer += `<th scope="col">${element}</th>`);
        tableContainer += `</tr>
                </thead>
                <tbody>
                </tbody>
            </table>`;
        legendContainer.innerHTML = tableContainer;
        tableContainer = legendContainer.querySelector('table');
    }

    return tableContainer;
};
const getOrCreateLegendList = (chart, id) => {
  const legendContainer = document.getElementById(id);
  let listContainer = legendContainer.querySelector('ul');

  if (!listContainer) {
    listContainer = document.createElement('ul');
    if (chart.config.type == 'bar') {
        legendContainer.insertBefore(listContainer, legendContainer.firstChild);  
    } else {
        legendContainer.appendChild(listContainer);
    }
  }

  return listContainer;
};
const formatLegendValue = (value, config) => {
    const { unit, hide_legend_unit, custom_unit } = config.options;
    
    // Check for intentionally blank or 0 values first
    if (value === 0 || value === null || value === '') {
        return "--"; // Display "--" for blank or zero values
    }

    value = parseFloat(value);

    let formattedValue;
    
    if (unit === 'percentage') {
        // Retain up to two decimal places only if necessary
        formattedValue = value % 1 === 0 ? value.toString() : value.toFixed(2);
        // Remove trailing zeros after decimal point and the decimal point if not needed
        if (!hide_legend_unit) {
            formattedValue = parseFloat(formattedValue).toString() + '%';
        } else {
            formattedValue = parseFloat(formattedValue).toString();
        }
    } else {
        // Determine the effective unit for this specific value
        let effectiveUnit = unit;
        if (unit === 'billion' && value < 1 && !hide_legend_unit) {
            value *= 1000; // Convert to millions for values less than 1 billion
            effectiveUnit = 'million'; // Temporarily adjust the unit for this value
        } 

        // For non-whole numbers, retain the original value; for whole numbers, remove decimal part
        if (value % 1 === 0) {
            // Value is a whole number, format accordingly
            formattedValue = value.toString();
        } else {
            // Value has a decimal part, determine precision needed
            formattedValue = value < 100 ? value.toFixed(2) : value.toFixed(1);
            // Remove trailing zeros after decimal point and the decimal point if not needed
            formattedValue = parseFloat(formattedValue).toString();
        }

        // Append the unit if the legend unit is not supposed to be hidden
        if (!hide_legend_unit) {
            switch (effectiveUnit) {
                case 'currency':
                    formattedValue = `$${formattedValue}`;
                    break;
                case 'million':
                    formattedValue += 'm';
                    break;
                case 'billion':
                    formattedValue += 'b';
                    break;
                default:
                    if (custom_unit) formattedValue += `${custom_unit}`;
                    break;
            }
        }
    }
    // Add commas to format large numbers
    formattedValue = formattedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return formattedValue;
};
const htmlLegendPlugin = {
  id: 'htmlLegend',
  afterUpdate(chart, args, options) {
    const {type} = chart.config;
    const legendContainer = document.getElementById(options.containerID) || document.getElementById(options.containerID + "-2");
    
    if (legendContainer) {
        legendContainer.classList.add(`${type}`);
    }
    
    if ((type === 'pie' || type === 'doughnut') && options.type == 'table') {
        const table = getOrCreateLegendTable(chart, options.containerID);
        const tbody = table.querySelector('tbody');
    
        // Remove old legend items
        while (tbody.firstChild) {
            tbody.firstChild.remove();
        }
    
        // Reuse the built-in legendItems generator
        const items = chart.options.plugins.legend.labels.generateLabels(chart);
        
        const total = chart.config.data.datasets[0].data.reduce((a, b) => parseInt(a) + parseInt(b), 0);
    
        items.forEach((item, datasetIndex) => {
            const row = document.createElement('tr');
        
            // Color Box
            const boxSpan = document.createElement('span');
            boxSpan.style.background = item.fillStyle;
            boxSpan.style.borderColor = item.strokeStyle;
            boxSpan.style.borderWidth = item.lineWidth + 'px';
            boxSpan.style.display = 'inline-block';
            boxSpan.style.height = '15px';
            boxSpan.style.marginRight = '8px';
            boxSpan.style.width = '15px';
            boxSpan.setAttribute('aria-hidden', 'true');
        
            // Text
            const textNode = document.createTextNode(item.text);
            const labelTextSpan = document.createElement('div');
            labelTextSpan.className = 'label-text';
            labelTextSpan.appendChild(textNode);
        
            // Label cell
            const labelCell = document.createElement('th');
            labelCell.className = 'label';
            labelCell.appendChild(boxSpan);
            labelCell.appendChild(labelTextSpan);
        
            // Value Cell
            const valueCell = document.createElement('td');
            valueCell.className = 'value';
        
            // Fetch the dataset value and format it using the formatLegendValue function
            let value = chart.config.data.datasets[0].data[datasetIndex];
            value = formatLegendValue(value, chart.config);
        
            // Create a text node for the value and append it to the value cell
            const valueNode = document.createTextNode(value);
            valueCell.appendChild(valueNode);
        
            // Append label and value cells to the row
            row.appendChild(labelCell);
            row.appendChild(valueCell);
            row.style.textDecoration = item.hidden ? 'line-through' : '';
        
            // Append the row to the tbody
            tbody.appendChild(row);
        });
    } else if ((type === 'pie' || type === 'doughnut') || options.type == 'list') {
        const ul = getOrCreateLegendList(chart, options.containerID);
        
        // Remove old legend items
        while (ul.firstChild) {
            ul.firstChild.remove();
        }
        
        // Reuse the built-in legendItems generator
        const items = chart.options.plugins.legend.labels.generateLabels(chart);
        
        items.forEach((item, datasetIndex) => {
            const li = document.createElement('li');
            
            let pointStyle = '';
            if (type == 'line') {
                pointStyle = settings.pointStyles[datasetIndex];
                item.fillStyle = settings.lineColors[datasetIndex];
            }
            
            // Color box
            const boxSpan = document.createElement('span');
            boxSpan.style.background = options.type == 'list' ? item.fillStyle : item.strokeStyle;
            boxSpan.style.borderColor = item.strokeStyle;
            boxSpan.style.borderWidth = item.lineWidth + 'px';
            boxSpan.style.display = 'inline-block';
            boxSpan.style.verticalAlign = 'middle';
            boxSpan.style.height = '15px';
            boxSpan.style.marginRight = '8px';
            boxSpan.style.width = '15px';
            if (pointStyle) {
                boxSpan.classList.add(pointStyle);
            }
            
            // Text
            const textContainer = document.createElement('p');
            textContainer.style.color = item.fontColor;
            textContainer.style.margin = 0;
            textContainer.style.padding = 0;
            textContainer.style.display = 'inline-block';
            textContainer.style.verticalAlign = 'middle';
            textContainer.style.textDecoration = item.hidden ? 'line-through' : '';
            
            const text = document.createTextNode(item.text);
            textContainer.appendChild(text);
            
            li.appendChild(boxSpan);
            li.appendChild(textContainer);
            ul.appendChild(li);
        });
    } else {
        let legendContainer = document.getElementById(options.containerID);
        if (!legendContainer) {
            legendContainer = document.getElementById(options.containerID + "-2");
        }
        
        const table = document.createElement('table');
        table.className = 'legend-table';
        const thead = document.createElement('thead');
        const tbody = document.createElement('tbody');

        const trLabel = document.createElement('tr');
        const thLabel = document.createElement('th');
        const labelText = chart.config.options.scales.x.title.text;
        thLabel.textContent = labelText ? labelText : 'Year';
        trLabel.appendChild(thLabel);
        
        chart.data.datasets.forEach((dataset, datasetIndex) => {
            const th = document.createElement('th');
            th.className = 'dataset-heading';
        
            // Create the label span
            const labelSpan = document.createElement('span');
            labelSpan.textContent = dataset.label;
        
            // Create the screen reader only span if needed
            let srSpan;
            if (dataset.sr_text) {
                srSpan = document.createElement('span');
                srSpan.className = 'sr-only';
                srSpan.textContent = dataset.sr_text;
            }
        
            // Create the background color span
            const colorSpan = document.createElement('span');
            colorSpan.style.background = type === 'line' ? dataset.borderColor : dataset.backgroundColor;
            if (type === 'line') {
                colorSpan.className = dataset.pointStyle;
            }
            colorSpan.style.display = 'inline-block';
            colorSpan.style.width = '15px';
            colorSpan.style.height = '15px';
            colorSpan.style.marginRight = '8px';
        
            // Create the wrapper span
            const wrapperSpan = document.createElement('span');
            wrapperSpan.className = 'label-wrapper';
        
            // Append the colored span and the label span to the wrapper
            wrapperSpan.appendChild(colorSpan);
            wrapperSpan.appendChild(labelSpan);
        
            // Append the screen reader only span if it exists
            if (srSpan) {
                wrapperSpan.appendChild(srSpan);
            }
        
            // Append the wrapper span to the table header
            th.appendChild(wrapperSpan);
            
            trLabel.appendChild(th);
        });

        thead.appendChild(trLabel);

        chart.data.labels.forEach((label, index) => {
            const tr = document.createElement('tr');
            const tdLabel = document.createElement('th');
            tdLabel.textContent = label;
            tr.appendChild(tdLabel);
        
            chart.data.datasets.forEach((dataset, datasetIndex) => {
                const td = document.createElement('td');
        
                // Fetch the dataset value for this label and format it using the formatLegendValue function
                let value = dataset.data[index];
                value = formatLegendValue(value, chart.config);
        
                // Set the formatted value as the text content of the td element
                td.textContent = value;
                if(options.containerID.includes('23701') && value && value !== '--') {
                    td.textContent = value ? '$' + value  : value;
                }
        
                // Append the td to the tr
                tr.appendChild(td);
            });
        
            // Append the tr to the tbody
            tbody.appendChild(tr);
        });
        table.appendChild(thead);
        table.appendChild(tbody);
        legendContainer.innerHTML = ''; // Clear the container
        legendContainer.appendChild(table);
    }
  }
};